// core
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

// environment
import { environment } from '@open-portal-env';

@Component({
  selector: 'documentsTemplate',
  templateUrl: './documents-template.component.html',
  styleUrls: ['./documents-template.component.scss']
})
export class DocumentsTemplateComponent implements OnInit {
  documentListing?: Array<any>;
  apiEndpoint = environment.apiEndpoint;

  constructor(
    private route: ActivatedRoute,
    public partnerBrandService: PartnerBrandService
  ) {}

  ngOnInit() {
    if (this.route.snapshot.data) {
      this.documentListing = this.route.snapshot.data.document;
    }
  }
}
